import type { UiMenuOptionType } from "@dpa-id-components/dpa-shared-components/src/components/UiMenu/UiMenu.vue";
import { computed, ref, type ShallowRef, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

import type { Filter } from "@/stores/search/filterSelector";
import { FilterType } from "@/types/enums.ts";
import type { rawFilterSet } from "@/types/ui.ts";

interface UseFilter {
  filterData: ShallowRef<rawFilterSet | null>;
}

function useFilter(serviceName: FilterType, { filterData }: UseFilter) {
  const { t } = useI18n();
  const route = useRoute();
  const selected = ref<string[]>([]);

  const filterMenu = computed<Filter>(() => {
    const values: UiMenuOptionType<string>[] =
      filterData.value?.[serviceName]?.map((value) => {
        return {
          label: value?.label
            ? value.label
            : t(`filters.mappedValues.${serviceName}.${value.key}`),
          value: value.key,
          selected: selected.value.some((selected) => selected == value.key),
        };
      }) ?? [];

    return {
      label: t(`filters.headlines.${serviceName}`),
      options: values,
    };
  });

  function resetSelectedFilters() {
    selected.value = [];
  }

  watch(
    () => route.query,
    (newVal) => {
      if (newVal[serviceName]) {
        const queryValue = newVal[serviceName];
        if (Array.isArray(queryValue)) {
          selected.value = queryValue.map((item) => {
            if (Array.isArray(item)) {
              return item.join(",");
            }
            return String(item);
          });
        } else if (typeof queryValue === "string") {
          selected.value = [queryValue];
        }
      } else {
        selected.value = [];
      }
    },
    { immediate: true },
  );

  return {
    selected,
    filterMenu,
    resetSelectedFilters,
  };
}

export default useFilter;
